import styled from '@emotion/styled'
import { CommonTitle } from '../../common'
import { CartType } from '../Cart'

interface Props {
  type: CartType
  reference?: string
}

const CartTitle = ({ type, reference }: Props) => {
  const title = type === CartType.Shop ? 'Your Cart' : 'Your Order'
  const fontSize = (type === CartType.Shop && '16px') || undefined
  return (
    <Content data-testid='cart-title'>
      <CommonTitle fontSize={fontSize}>{title}</CommonTitle>
      {reference && (
        <p>
          Order ID: <span>{reference}</span>
        </p>
      )}
    </Content>
  )
}

const Content = styled.div(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  'p > span': {
    fontWeight: 500
  }
}))

export default CartTitle
